import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RepairStatusType } from "../../../components/organisms/Reservation/Tags/RepairStatus";

export interface ReservationState {
  repairNo?: string | undefined;
  orderedAt?: string | undefined;
  reservedAt?: string | undefined;
  reservedStatus?: RepairStatusType | undefined;
}

const initialState: ReservationState = {};

/**
 * 예약정보-상세용
 */
const ReservationSlice = createSlice({
  name: "reservation",
  initialState,
  reducers: {
    setReservation(state, action: PayloadAction<ReservationState>) {
      const parse = action.payload;

      state = parse;

      return state;
    },
  },
});

const { reducer: reservationReducer, actions } = ReservationSlice;
export const { setReservation } = actions;
export default reservationReducer;
